// Import the functions you need from the SDKs you need
import Axios from "axios";
import {
    initializeApp
} from "firebase/app";
import {
    getMessaging,
    onMessage,
    getToken
} from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyDEMwIr2n3Y3wO99ygQT7pXuKFuG8WnVIg",
    authDomain: "cia-de-maria.firebaseapp.com",
    projectId: "cia-de-maria",
    storageBucket: "cia-de-maria.appspot.com",
    messagingSenderId: "519826489584",
    appId: "1:519826489584:web:e49daab03ae70368ba4235"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);




export const onMessageListener = () =>
    new Promise((resolve) => {
        onMessage(messaging, (payload) => {
            resolve(payload);
        });
    });

export const getUserToken = (id = null) => {
    try {
        return getToken(messaging, {
            vapidKey: 'BMYQt6o9GQzAhcLvxdVaP5yJyE-xozXCsoRNspY3k5vcPrHHMk6THpCvWS_FMqrccCQSGI8B5og47H3woZk9BTY'
        }).then((currentToken) => {
            if (currentToken && localStorage.getItem('fcm') === null) {
                if (id) {
                    Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/pushnotifications/checktoken', {
                        user: id,
                        token: {
                            currentToken
                        }
                    });
                    localStorage.setItem('fcm', currentToken);
                } else {
                    // setTokenFound(true);
                    Axios.post(process.env.REACT_APP_DB_ADDRESS + '/api/pushnotifications/checktoken', {
                        user: JSON.parse(sessionStorage.getItem('userInfo'))._id,
                        token: {
                            currentToken
                        }
                    });
                    localStorage.setItem('fcm', currentToken);
                }
                // Track the token -> client mapping, by sending to backend server
                // show on the UI that permission is secured
            } else {
                // setTokenFound(false);
                // shows on the UI that permission is required 
            }
        }).catch((err) => {
            if (localStorage.getItem('fcm')) {
                Axios.delete(process.env.REACT_APP_DB_ADDRESS + '/api/pushnotifications/' + localStorage.getItem('fcm'));
                localStorage.removeItem('fcm');
            }
            // console.log('An error occurred while retrieving token. ', err);
            // catch error while creating client token
        });
    } catch (error) {
        
    }
}

export const removeUserToken = () => {
    if (localStorage.getItem('fcm')) {
        Axios.delete(process.env.REACT_APP_DB_ADDRESS + '/api/pushnotifications/' + localStorage.getItem('fcm'));
        localStorage.removeItem('fcm');
    }
}